import type { Timezone } from "@tellescope/types-models";

export interface ResolveEventDisplayTimezoneOptions {
  userIds: string[];
  users: { id: string; timezone?: Timezone }[];
  fallbackTimezone: string;
}

export const resolveEventDisplayTimezone = ({
  userIds,
  users,
  fallbackTimezone,
}: ResolveEventDisplayTimezoneOptions): string => {
  if (userIds.length !== 1) return fallbackTimezone;

  const selectedUser = users.find((user) => user.id === userIds[0]);

  return selectedUser?.timezone ?? fallbackTimezone;
};
